import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  PiCalendarDuotone,
  PiHouseDuotone,
  PiTrophyDuotone,
  PiUserCirclePlusDuotone,
  PiUserDuotone,
} from 'react-icons/pi';
import { NotificationProvider } from '../../app/providers/NotificationContext';
import Sidebar from './Sidebar';
import Header from './Header';
import './Layout.css';

const BOTTOM_NAV_ITEMS = [
  { to: '/dashboard', icon: <PiHouseDuotone size={22} />, label: 'Главная' },
  { to: '/rooms', icon: <PiTrophyDuotone size={22} />, label: 'Комнаты' },
  { to: '/events', icon: <PiCalendarDuotone size={22} />, label: 'События' },
  { to: '/friends', icon: <PiUserCirclePlusDuotone size={22} />, label: 'Друзья' },
  { to: '/profile', icon: <PiUserDuotone size={22} />, label: 'Профиль' },
];

export default function Layout({ children }) {
  return (
    <NotificationProvider>
      <div className="bm-layout">
        <Sidebar />

        <main className="bm-layout__main">
          {/* Header виден только на мобильных, где Sidebar скрыт */}
          <Header />
          <div className="bm-layout__content">
            {children}
          </div>
        </main>

        <BottomNav />
      </div>
    </NotificationProvider>
  );
}

function BottomNav() {
  return (
    <nav className="bm-bottom-nav">
      <div className="bm-bottom-nav__items">
        {BOTTOM_NAV_ITEMS.map(({ to, icon, label }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `bm-bottom-nav__item${isActive ? ' bm-bottom-nav__item--active' : ''}`
            }
          >
            <span className="bm-nav-icon-wrap">{icon}</span>
            <span>{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
